import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import WhatsAppWidget from '@/components/WhatsAppWidget';

const Layout = ({ children }) => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const menuItems = [
    { label: 'Home', path: '/' },
    { label: 'Blog', path: '/blog' },
    { label: 'Services', path: '/services' },
    { label: 'Case Studies', path: '/case-studies' },
    { label: 'Downloads', path: '/downloads' },
    { label: 'Contact', path: '/contact' }
  ];

  return (
    <div className="min-h-screen">
      <header className="fixed top-0 left-0 right-0 z-50 primary-green">
        <div className="content-container">
          <nav className="flex items-center justify-between py-3">
            <Link to="/" className="flex items-center" data-testid="logo-link">
              <img src="/nde-logo.jpg" alt="NDE Business" className="h-16 w-auto" />
            </Link>

            <div className="hidden md:flex items-center space-x-8">
              {menuItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
                  className={`font-uni-sans text-base font-medium transition-colors duration-300 ${
                    location.pathname === item.path ? 'text-neutral-gray' : 'text-white hover:text-neutral-gray'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </div>

            <button
              className="md:hidden text-white"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-toggle"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </nav>

          {mobileMenuOpen && (
            <div className="md:hidden pb-4" data-testid="mobile-menu">
              {menuItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className="block py-2 font-uni-sans text-base font-medium text-white hover:text-neutral-gray transition-colors"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          )}
        </div>
      </header>

      <main className="pt-20">{children}</main>

      <footer className="bg-[#646464] text-white">
        <div className="content-container section-spacing">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="ml-10">
              <div className="mb-4">
                <img src="/nde-logo.jpg" alt="NDE Business" className="h-16 w-auto mb-3" />
                <h3 className="font-rubik font-bold text-xl">NDE TRAINING & CONSULTANCY</h3>
              </div>
              <p className="font-roboto text-base leading-relaxed">
                Hannaslustweg 177<br />
                District Wanica<br />
                Suriname
              </p>
            </div>

            <div>
              <h4 className="font-rubik font-semibold text-lg mb-4">Quick Links</h4>
              <ul className="space-y-2">
                {menuItems.map((item) => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className="font-roboto text-base hover:text-[#aaae10] transition-colors"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-rubik font-semibold text-lg mb-4">CONNECT WITH US</h4>
              <div className="flex space-x-4">
                <a
                  href="mailto:Ndetraining2023@gmail.com"
                  data-testid="email-link"
                  className="w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-[#aaae10] transition-colors"
                >
                  <svg className="w-5 h-5 fill-[#646464]" viewBox="0 0 24 24">
                    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                  </svg>
                </a>
                <a
                  href="https://wa.me/5978600350"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="whatsapp-footer-link"
                  className="w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-[#aaae10] transition-colors"
                >
                  <svg className="w-5 h-5 fill-[#646464]" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-black py-4">
          <div className="content-container text-center">
            <p className="font-roboto text-base text-white">
              Copyright © NDE Business 2026. All rights reserved.
            </p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Widget */}
      <WhatsAppWidget />
    </div>
  );
};

export default Layout;
